<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kas Cabang</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.tanggal" name="filterTable"
                            id="filterInput"
                            type="date"
                        ></b-form-input>
                        <b-form-input class="mr-2"
                            v-model="input.filterNamaCabang" name="filterNamaCabang"
                            type="search"
                            id="filterNamaCabang"
                            placeholder="Masukkan nama cabang"
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter(filter)"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="exportExcelBtn" @click="openExportExcelModal">Export Excel</b-button>
            </div>
            <b-table bordered hover show-empty sticky-header :style="`max-height: ${window.tableHeight}`"
                :busy="isBusy"
                :items="dataKasCabang" 
                :fields="fields"
                responsive class="mb-0">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas cabang.
                </template>
                <template v-slot:cell(kasBrankas)="row">
                    <div class="text-right no-wrap" v-if="row.item.kasBrankas == null">{{$helper.addThousandSeparator(row.item.kasBrankas)}} </div>
                    <div class="text-right no-wrap" v-else-if="row.item.kasBrankas < 0">- Rp{{$helper.addThousandSeparator(row.item.kasBrankas).replace("-", "")}}</div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kasBrankas)}} </div>
                </template>
                <template v-slot:cell(kasLaci)="row">
                    <div class="text-right no-wrap" v-if="row.item.kasLaci == null">{{$helper.addThousandSeparator(row.item.kasLaci)}} </div>
                    <div class="text-right no-wrap" v-else-if="row.item.kasLaci < 0">- Rp{{$helper.addThousandSeparator(row.item.kasLaci).replace("-", "")}}</div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kasLaci)}} </div>
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominal == null">{{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no-wrap" v-else-if="row.item.nominal < 0">- Rp{{$helper.addThousandSeparator(row.item.nominal).replace("-", "")}}</div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                </template>
            </b-table>
        </b-card>
        <ModalConfirm id="modal-confirm-exportExcel" title="Confirm Export Excel" :isSubmitting="isSubmitting" :desc="`Apakah anda yakin untuk melakukan Export Excel data kas cabang untuk tanggal ${$helper.changeDateFormat(input.tanggal)} ?`" @submit="onExportExcel" />
    
    </div>
</template>

<script>
export default {
    name: 'kas-cabang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input:{
                tanggal: "",
                filterNamaCabang: null,
            },
            activeInputTanggal : "",
            fields: [
                { key: "cabangName", label: "Nama Cabang", sortable: true },
                { key: "kasBrankas", label: "Kas Brankas", sortable: true },
                { key: "kasLaci", label: "Kas Laci", sortable: true },
                { key: "nominal", label: "Total Nominal", sortable: true },
            ],
            filter: null,
            dataKasCabangAll: [],
            dataKasCabang: [],
            dataKasCabangOld: [],
            window: {
                tableHeight: 0,
            },
            query: "",
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 1

            let today = new Date();
            let dd = today.getDate();

            let mm = today.getMonth()+1; 
            let yyyy = today.getFullYear();

            if(dd<10) 
            {
                dd='0'+dd;
            } 

            if(mm<10) 
            {
                mm='0'+mm;
            } 

            let date = yyyy+'-'+mm+'-'+dd;

            this.input.tanggal = date
            this.activeInputTanggal = date

            this.query = "?tanggal=" + this.input.tanggal
            let getDataKasCabang = this.$axios.get("laporan/kas-cabang/"+this.query).then(response => {
                this.dataKasCabangAll = response.data
                this.dataKasCabangOld = response.data
                this.dataKasCabang = response.data
           
            })

            Promise.all([getDataKasCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getNewDataKasCabang(){
            this.toggleBusy()
            this.dataKasCabang = []
            this.query = "?tanggal=" + this.input.tanggal
            if(this.input.tanggal == this.activeInputTanggal){
                if(this.input.filterNamaCabang != null){
                    let arrayCopy = [...this.dataKasCabangAll]
                    let menuFilter = arrayCopy.filter(item => item.cabangName.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase()))
                    this.dataKasCabang = menuFilter  
                    this.toggleBusy() 
                 
                }else{
                    this.getDataKasCabang()
                }
            }else{
                this.$axios.get("laporan/kas-cabang/"+this.query).then(response => {
                    this.dataKasCabangAll = response.data
                    this.activeInputTanggal = this.input.tanggal
             
                    if (this.input.filterNamaCabang != null){
                        let arrayCopy = [...response.data]
                        let menuFilter = arrayCopy.filter(item => item.cabangName.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase()))
                        this.dataKasCabang = menuFilter  
                        this.toggleBusy() 
                    }else{
                        this.dataKasCabang = response.data
                        this.toggleBusy() 
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                })
            }
        },

        //-----------------  Fungsi Ambil Data dataKasCabang ----------------- 
        
        getDataKasCabang(){
            this.dataKasCabang = this.dataKasCabangOld
            this.toggleBusy()
        },

        onFilter(){

            if(!this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                this.$helper.toastErr(this, "Mohon isi tanggal!")
            }else{
                this.getNewDataKasCabang()
            }

        },

        onReset(){
            let today = new Date();
            let dd = today.getDate();

            let mm = today.getMonth()+1; 
            let yyyy = today.getFullYear();

            if(dd<10) 
            {
                dd='0'+dd;
            } 

            if(mm<10) 
            {
                mm='0'+mm;
            } 

            let date = yyyy+'-'+mm+'-'+dd;
            this.input.tanggal = date
            this.activeInputTanggal = date
            this.input.filterNamaCabang = null
            this.toggleBusy()
            this.getDataKasCabang()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        handleResize() {
            let windowHeight = window.innerHeight
            let tableHeight = windowHeight - (55+46+50+82+51+48)
            this.window.tableHeight = tableHeight+'px'
        },

        openExportExcelModal(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                this.$helper.toastErr(this, "Mohon isi tanggal!")
            }else{
                this.$bvModal.show("modal-confirm-exportExcel")
            }
        },

        download(data, fileName) {
            var element = document.createElement('a');
            element.setAttribute('href', data);
            element.setAttribute('download', fileName);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },

        onExportExcel(){
            this.query = "?tanggal="+this.input.tanggal
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.get("laporan/kas-cabang/download/"+this.query).then(response => {
               
                this.$helper.toastSucc(this, "Export Excel berhasil dilakukan!")
                this.$bvModal.hide("modal-confirm-exportExcel")
                let url = this.$baseFilePath+response.data.name

                this.download(url, "Laporan Kas Cabang")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

    },
    created(){
        this.init()
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
}
</script>
